import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import WebinarDetail from "@/pages/WebinarDetail";
import { WEBINARS_ENABLED } from "@/config/featureFlags";
import { Navigate } from "@/lib/router-compat";

export const Route = createFileRoute("/webinars/$id")({
  head: ({ params }) => seoHead(`/webinars/${params.id}`),
  component: () => (WEBINARS_ENABLED ? <WebinarDetail /> : <Navigate to="/learn" replace />),
});